/*
 * 2019 Design System color palatte.
 * Should only be accessed from theme.js, and never directly.
 *
 * Don't add/remove without signoff from #design-systems
 */
const blue = '#0052FF';
const white = '#FFFFFF';
const black70 = '#050F19';
const grey60 = 'rgba(17,51,83,0.6)';
const grey6 = '#ECEFF1'; // Restricted use greys

export { black70, blue, grey6, grey60, white };
//# sourceMappingURL=colors.js.map
